import { render, staticRenderFns } from "./IconCirculeRisk.vue?vue&type=template&id=243ff738"
import script from "./IconCirculeRisk.vue?vue&type=script&lang=js"
export * from "./IconCirculeRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports